import { useTranslation } from "@flare/i18n";
import { Divider, Heading, Icon, Text } from "@flare/ui/components";

export function PriceInfoCard({
  nextStepsText,
  price,
}: {
  nextStepsText: string;
  price: number;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-sp-4 rounded-lg bg-neutral px-sp-5 pb-sp-6 pt-sp-5">
      <div className="flex items-center justify-between">
        <Heading variant="h5">
          {t("FUNNEL_CHECKOUT_FORM_PRICE_INFO_TITLE")}
        </Heading>
        <Heading variant="h5">{`$${price}`}</Heading>
      </div>
      <Divider />
      <ul className="flex flex-col gap-sp-3">
        <li className="flex items-center gap-sp-2">
          <Icon name="check-circle" color="action" />
          <Text variant="body2">
            {t("FUNNEL_CHECKOUT_FORM_PRICE_INFO_BULLET_1")}
          </Text>
        </li>
        <li className="flex items-center gap-sp-2">
          <Icon name="check-circle" color="action" />
          <Text variant="body2">{nextStepsText}</Text>
        </li>
      </ul>
    </div>
  );
}
